import { CustomerIndexViewModel } from '@ail/customers-api'
import { useAuth } from '../../../../hooks/useAuth'
import DeliveryCompanySelector from '../../../DeliveryAndReturns/DeliveryCompanySelector'
import { DriverSelectionModal } from '../../../DeliveryAndReturns/DriverSelectionModal'
import { ColumnFilter, GridColumn } from '../Grid'
import './FilterModal.scss'
import ContractsDropDownFilterModal from '../../../GeneralContracts/ContractsDropDownFilterModal/ContractsDropDownFilterModal'
import ReplacementStateSelector from '../../../GeneralContracts/ReplacementState/ReplacementStateSelector'

interface FilterModalProps<T> {
  column?: GridColumn<T>
  onChange: (key: string, filter: ColumnFilter<T>) => void
  onClose: () => void
}
export function FilterModal<T>(props: FilterModalProps<T>) {
  const { user } = useAuth()
  const key = props.column?.key
  const filter = props.column?.filter

  if (!filter || !key || !filter.type.startsWith('modal')) {
    return null
  }

  switch (filter.type) {
    case 'modal_delivery_customer_filter':
      return (
        <DeliveryCompanySelector
          visible={!!filter}
          closeModal={(companies: CustomerIndexViewModel[]) => {
            props.onChange(key, {
              ...filter,
              value: companies.length ? companies.map((c) => c.value!) : undefined,
            })
            props.onClose()
          }}
          user={user}
          customers={filter.data ?? []}
          currentSelectedCustomersKeys={filter.value}
        />
      )
    case 'modal_replacement_state_filter':
      return (
        <ReplacementStateSelector
          onClose={props.onClose}
          handleSelectionChange={(items) => props.onChange(key, { ...filter, value: items })}
          currentSelection={filter.value}
          availableOptions={filter.data}
        />
      )

    case 'modal_driver_filter':
      return (
        <DriverSelectionModal
          visible={!!filter}
          selectedDriver={filter.value}
          filterChanged={(items) => props.onChange(key, { ...filter, value: items })}
          onClose={props.onClose}
        />
      )

    case 'modal_contracts_dropdown_filter':
      return (
        <ContractsDropDownFilterModal
          title={filter.title}
          onClose={props.onClose}
          filterChanged={(items) => {
            props.onChange(key, {
              ...filter,
              value: items.length ? items : undefined,
            })
          }}
          translationPrefix={filter.transPrefix}
          allItems={filter.data ?? []}
          currentFilter={filter.value ?? []}
          visible={!!filter}
        />
      )
    default:
      return null
  }
}
